module.exports = __webpack_public_path__ + "static/media/arrow_down.a9d03831.svg";